import { AppOptionsContextProvider } from 'contexts/app-options';
import { ErrorBoundaryFallback } from 'epion-checkin/components/error-boundary-fallback';
import { CaptureCountlyEventsContextProvider } from 'epion-checkin/context/capture-countly-events';
import { ThemeProvider } from 'epion-checkin/theme/theme-provider';
import { appConfig } from 'modules/app-config';
import { initCountly } from 'modules/countly';
import { initDatadog } from 'modules/datadog';
import { installPolyFills } from 'polyfills';
import { createRoot } from 'react-dom/client';
import { EpionCheckInRoot } from 'roots/epion-checkin';
import { epionCheckInConfigSchema } from 'schemas/app-config';

const render = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const departmentId = urlParams.get('departmentId') || '';

    const options = {
        rootElementId: 'root',
        type: 'epion-checkin',
        departmentId,
    } as const;

    const root = createRoot(document.getElementById(options.rootElementId)!);

    try {
        // Installing necessary polyfills should always be the first to execute
        await installPolyFills();

        initCountly();
        initDatadog(appConfig.citymdCheckin.datadog);

        const validatedOptions = epionCheckInConfigSchema.validateSync(options);

        root.render(<EpionCheckInRoot options={validatedOptions} />);
    } catch (error) {
        root.render(
            <ThemeProvider>
                <AppOptionsContextProvider options={options}>
                    <CaptureCountlyEventsContextProvider departmentId={undefined}>
                        <ErrorBoundaryFallback error={error as Error} />
                    </CaptureCountlyEventsContextProvider>
                </AppOptionsContextProvider>
            </ThemeProvider>
        );
    }
};

const { version } = appConfig;
console.info(`CityMD Check-In version: ${version} @ ${__VMD_RELEASE_DATE__}`);

render();
